import { EntityViewConfig, entityViewConfig } from './type';
import runtimeValidatedJSONParse from '../../util/runtimeValidatedJSONParse';

export const parseConfig = (json: string) => runtimeValidatedJSONParse<EntityViewConfig>(entityViewConfig)(json);
